import { MatIconRegistry } from '@angular/material/icon';
import { IBaseListWebItem } from './../../shared/components/base-list-web/base-list-web-item.model';
import { CoreService } from '@web/base/core/core.service';
import { BaseWebComponent } from '@web/shared/components/base-web/base-web.component';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '@web/base/shared/shared.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { IResponse } from '@web/base/shared/models/response.model';
import { ConstantsProject } from '@web/project/shared/constants.class';
import { BehaviorSubject, Subject } from 'rxjs';
import { URL_WEB } from './../../../../environments/environment';
import { SlugifyPipe } from '@web/base/shared/pipes/slugify.pipe';
import { AuthService } from '@web/base/auth/auth.service';
import { order } from '@web/base/shared/utils';
import { Moment } from 'moment';

@Component({
  selector: 'web-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent extends BaseWebComponent implements OnInit, OnDestroy {
  section = 'home';
  // showSidenav = false;

  isMobile;

  queries = [];
  queriesBestRatings = [];
  showBreadcrumb;

  bannersCarruselHome = [];
  bannersSidenav = [];

  // private sliderContent = new Subject<Array<IBaseListWebItem>>();
  // public sliderContent$ = this.sliderContent.asObservable();

  private gridContent = new Subject<Array<IBaseListWebItem>>();
  public gridContent$ = this.gridContent.asObservable();

  private listContent = new Subject<Array<IBaseListWebItem>>();
  public listContent$ = this.listContent.asObservable();

  private contentsObservatoriesPortals = new Subject<Array<IBaseListWebItem>>();
  public contentsObservatoriesPortals$ = this.contentsObservatoriesPortals.asObservable();

  CONTENTS_OBSERVATORIES_PORTALS = ConstantsProject.CONTENTS_OBSERVATORIES_PORTALS;
  CONTENTS_NEWS = ConstantsProject.CONTENTS_NEWS;
  CONTACTS_FEATURED = ConstantsProject.CONTACTS_FEATURED;
  CONTACTS_BEST_RATINGS = ConstantsProject.CONTACTS_BEST_RATINGS;

  private events: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([]);
  public events$ = this.events.asObservable();
  private oldMonth: string;

  public loadingEvents: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  public loadingEvents$ = this.loadingEvents.asObservable();

  constructor(
    translate: TranslateService,
    public snackbar: MatSnackBar,
    public dialog: MatDialog,
    public meta: Meta,
    public title: Title,
    public route: ActivatedRoute,
    public sharedService: SharedService,
    public coreService: CoreService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    public slugPipe?: SlugifyPipe,
    private authService?: AuthService,
    public router?: Router
  ) {
    super(translate, snackbar, dialog, meta, title, route, sharedService);

    iconRegistry.addSvgIcon('ico_novedades', sanitizer.bypassSecurityTrustResourceUrl(URL_WEB + 'assets/img/ico_novedades.svg'));
    iconRegistry.addSvgIcon('ico_consultas', sanitizer.bypassSecurityTrustResourceUrl(URL_WEB + 'assets/img/ico_consultas.svg'));
    iconRegistry.addSvgIcon('ico_consultas_destacadas', sanitizer.bypassSecurityTrustResourceUrl(URL_WEB + 'assets/img/ico_consultas_destacadas.svg'));
    iconRegistry.addSvgIcon('ico_observatorios_novedades', sanitizer.bypassSecurityTrustResourceUrl(URL_WEB + 'assets/img/ico_observatorios_novedades.svg'));
  }

  ngOnInit() {
    super.ngOnInit();

    this.coreService.isMobile$.subscribe(v => this.isMobile = v);

    setTimeout(() => this.sharedService.showBreadcrumb.next(false));

    this.coreService.loadCover().subscribe((v: IResponse) => {

      // Banners
      this.bannersCarruselHome = v.result.banners
        .filter(b => b.bannerPositionID === ConstantsProject.BANNER_CARRUSEL_HOME)
        .sort((a, b) => order(a, b));

      this.bannersSidenav = v.result.banners
        .filter(b => b.bannerPositionID === ConstantsProject.BANNER_SIDE)
        .sort((a, b) => order(a, b));

      // Elementos de la portada
      // this.sliderContent.next(v.result.sliderContent);
      this.gridContent.next(v.result.gridContent);
      this.listContent.next(v.result.listContent);

      // Observatorios y Portales
      this.contentsObservatoriesPortals.next(v.result.contentsObservatoriesPortals);

      // Consultas destacadas
      this.queries = v.result.queries;
      this.queries.map(e => {
        e.url = '/consultas/' + e.contactTypeID + '/' + this.slugPipe.transform(e.contactType) + '/consulta/' + e.contactID + '/' + this.slugPipe.transform(e.subject);
        return e;
      });

      // Consultas mejor valoradas
      this.queriesBestRatings = v.result.queriesBestRatings;
      this.queriesBestRatings.map(e => {
        e.url = '/consultas/' + e.contactTypeID + '/' + this.slugPipe.transform(e.contactType) + '/consulta/' + e.contactID + '/' + this.slugPipe.transform(e.subject);
        return e;
      });

    });
  }

  ngOnDestroy() {
    this.sharedService.showBreadcrumb.next(true);
  }

  handleToBanner(url, event: Event) {
    event.preventDefault(); // evita que el navegador recargue o navegue

    if (this.authService.user && this.authService.user.fhn) {
      this.sharedService.loadURLBanner(url, this.authService.user.email).subscribe(res => {
        if (res) {
          const link = document.createElement('a');
          link.title = 'vg-tirant';
          link.href = res['result'];
          link.target = '_blank';
          link.download = 'true';

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
    } else {
      if (url.indexOf('tirant') !== -1) {
        this.router.navigateByUrl('p/112514/base-de-datos-tirant-lo-blanch');
      } else {
        this.router.navigateByUrl('p/112515/biblioteca');
      }
    }
  }

  more(type) {

    // Llamamos a la url y le pasamos el nombre de la sección
    this.getTranslations(['core', 'home']).then(() => {

      switch (type) {
        case this.CONTENTS_OBSERVATORIES_PORTALS:
          this.router.navigateByUrl('contenidos/mostrar/todos/' + type + '/' + this.slugPipe.transform(this.translations['home']['latestUpdates']));
          break;

        case this.CONTENTS_NEWS:
          this.router.navigateByUrl('contenidos/mostrar/todos/' + type + '/' + this.slugPipe.transform(this.translations['home']['news']));
          break;

        // María. 17/03/2023. Se añade el bóton más en consultas destacadas
        case this.CONTACTS_FEATURED:
          this.router.navigateByUrl('contenidos/mostrar/todos/' + type + '/' + this.slugPipe.transform(this.translations['home']['featuredQueries']));
          break;

        // María. 17/03/2023. Se añade el bóton más en consultas mejor valoradas
        case this.CONTACTS_BEST_RATINGS:
          this.router.navigateByUrl('contenidos/mostrar/todos/' + type + '/' + this.slugPipe.transform(this.translations['home']['ratingQueries']));
          break;

        default:
          break;
      }
    });

  }

  /** Funciones para el calendario */

  dateSelected(value: Moment) {
    if (value && (value.format('MM') !== this.oldMonth)) {
      this.oldMonth = value.format('MM');
      this.loadCalendar(value);
    }
  }

  loadCalendar(value: Moment) {
    this.events.next([]);
    setTimeout(() => this.loadingEvents.next(true));
    this.coreService.loadEventsByMonthAndYear(+value.format('MM'), +value.format('YYYY')).subscribe((res: IResponse) => {
      this.events.next(res.result);
      setTimeout(() => this.loadingEvents.next(false));
    }, err => {
      console.log('err', err);
      setTimeout(() => this.loadingEvents.next(false));
    });
  }
}
